<template>
  <div id="top_jumbotron" class="col">
    <svg viewBox="0 0 932 932" xmlns="http://www.w3.org/2000/svg">
      <g font-size="250">
        <text letter-spacing="-.07em" transform="translate(0 376.5)">
          FEEL
          <tspan letter-spacing="-.11em" x="546.24" y="0">I</tspan>
          <tspan letter-spacing="-.09em" x="599.74" y="0">NG</tspan>
          <tspan x="5" y="338">S</tspan>
          <tspan letter-spacing="-.09em" x="148.75" y="338">ONG</tspan>
        </text>
        <g letter-spacing="-.1em">
          <text transform="matrix(.98 0 0 1 7.39 545.5)">
            O
            <tspan letter-spacing="-.1em" x="158.02" y="0">N</tspan>
            <tspan letter-spacing="-.09em" x="319.77" y="0">E</tspan>
          </text>
          <text transform="matrix(.98 0 0 1 5.39 207.5)">
            O
            <tspan letter-spacing="-.1em" x="158.02" y="0">N</tspan>
            <tspan letter-spacing="-.09em" x="319.77" y="0">E</tspan>
          </text>
        </g>
        <text y="740" x="7" font-size="23.5">
          AN AUDIO LIBRARY BASED ON THE WHEEL OF COLORS
        </text>
      </g>
    </svg>
  </div>
</template>

<style scoped>
#top_jumbotron svg :is(text, tspan) {
  font-family: "Work Sans", sans-serif;
  font-weight: 700;
}
</style>
